import './styles.scss'
import PropTypes from 'prop-types'

const ToolTip = (props) => {
  return (
    <div className={'ToolTip ' + props.className}>
      {props.children}
    </div>
  )
}

ToolTip.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export default ToolTip
